import $axios from "@/api";

const state = () => ({

})

const mutations = {

}

const actions = {
    getListSalesman({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`/salesman`, {
                params: payload
            }).then((response) => {
                resolve(response.data.data)
                // console.log(response.data.data)
            })
        })
    },
    getListSalesmanActive({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`/salesman/get/salesman_active`, {
                params: payload
            }).then((response) => {
                resolve(response.data.data)
            })
        })
    },
    getListSalesmanPenjualan({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`/salesman/list/by_penjualan`, {
                params: payload
            }).then((response) => {
                resolve(response.data.data)
            })
        })
    },
    getListSalesmanPrincipal({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`/salesman/get/salesman_principal`, {
                params: payload
            }).then((response) => {
                resolve(response.data.data)
            })
        })
    },
    async getListSalesmanSpv({state},payload){
        try {
            const response = await $axios.get('/sales_supervisor',{params: payload})
            return response.data.data
        } catch (error) {
            console.log(error)
        }
    },
    async getListInvoiceBySales({state}, id_salesman){
        try {
            const response = await $axios.get(`penjualan/list/penjualan_by_salesman/${id_salesman}`)
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    getListSalesmanSimple({ state, commit }, payload) {
        return new Promise((resolve, reject) => {
            $axios.get(`/salesman/get/simple`, {
                params: payload
            }).then((response) => {
                resolve(response.data.data)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
